import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useLayout } from '../../../contexts/LayoutContext';
import SearchBar from './searchBar';
import AppMenu from './appmenu';

import Hamburger from '../../../assets/images/tabbar/Hamburger.png';
import peace from '../../../assets/images/hand/peace.png';
import Image from '../../Image';
import { useTranslation } from 'react-i18next';


const StyledAppBar = styled(AppBar)(({ theme }) => ({
    zIndex: (theme) => theme.zIndex.drawer + 1,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    backgroundColor: theme.palette.background.paper,
    transition: '0.3s ease-in-out',
    alignSelf: "flex-end",
    display: 'flex',
    height: '100px',
    justifyContent: 'center',
    boxShadow: "none",
    alignItems: "normal"
}));

const Header = React.memo(({ title }) => {
    const { t } = useTranslation();
    const { drawerWidth, toggleMobileMenu, isCollapsed, isMobile } = useLayout();
    const [search, setSearch] = React.useState('');

    return (
        <StyledAppBar key="header" position="sticky" sx={{ ml: { sm: 0, md: `${drawerWidth}px` }, width: `calc(100% - ${isMobile ? 0 : drawerWidth}px)`, px: { sm: "5px", md: "10px" } }} >
            <Toolbar key="toolbar" sx={{ gap: { xs: 1, md: 3 }, mt: "20px" }}>
                <Typography variant="h4" color="#1A1A1A" gap={"15px"} fontWeight="500" flexDirection={"row"} display={{ xs: "none", lg: "flex" }} alignItems={"center"}>{t('header.welcome')} <Image src={peace} /></Typography>
                {isMobile &&
                    <IconButton onClick={toggleMobileMenu} sx={{ color: 'black' }}>
                        <Image src={Hamburger} />
                    </IconButton>
                }
                {/* <SearchBar value={search} onChange={setSearch} /> */}
                <AppMenu />
            </Toolbar>
        </StyledAppBar>
    );
});

Header.propTypes = {
    onMenuClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
};

export default Header;